import { FONT_SIZES, type FontSize } from "@corca/data";
import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Sidebar } from "@/components/sidebar";
import { Dropdown } from "@/components/sidebar/Dropdown";

import type { ComponentProps } from "react";

type Props = {
  fontSize?: FontSize;
  onChange: (fontSize: FontSize) => void;
  triggerProps?: ComponentProps<"div">;
  tooltipTitle?: string;
};

export const FontSizeDropdown = observer(function FontSizeDropdown({
  fontSize,
  onChange,
  triggerProps,
  tooltipTitle,
}: Props) {
  const t = useTranslations("sidebar");
  const title = `${fontSize || "--"}px`;

  const items = FONT_SIZES.map((itemFontSize) => ({
    title: itemFontSize === "24" ? "4" : itemFontSize,
    active: fontSize === itemFontSize,
    superscript:
      itemFontSize === "11" || itemFontSize === "13" || itemFontSize === "17"
        ? t("textStyle.prime")
        : undefined,
    title2: itemFontSize === "24" ? "!" : undefined,
    onClick: () => {
      onChange(itemFontSize);
    },
  }));

  return (
    <Dropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          as="div"
          title={title}
          tooltipTitle={tooltipTitle || t("textStyle.textSize")}
          hintKey="textSize"
          {...triggerProps}
        />
      }
      items={items}
      itemsClassName="min-w-[80px]"
    />
  );
});
